import { HELIX_CRQS_ACTIONS } from '../Actions/HelixCrqsActions';

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const isSameData = (prev, next) =>
	JSON.stringify(prev) === JSON.stringify(next);

// ─── INITIAL STATE ─────────────────────────────────────────────────────────────
const initialState = {
	loading: {
		crqsToCreate:          false,
		crqsOnQueueWithError:  false,
		crqsAction:            false,
	},
	crqsToCreate:         [],
	crqsOnQueueWithError: [],
	error: null,
};

// ─── REDUCER ──────────────────────────────────────────────────────────────────
const HelixCrqsReducer = (state = initialState, action) => {
	switch (action.type) {

					// ── Creations: Get CRQs to Create ─────────────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_REQUEST:
						return { ...state, loading: { ...state.loading, crqsToCreate: true }, error: null };

					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_SUCCESS: {
						const next = action.payload ?? [];
						if (isSameData(state.crqsToCreate, next))
							return { ...state, loading: { ...state.loading, crqsToCreate: false } };
						return { ...state, loading: { ...state.loading, crqsToCreate: false }, crqsToCreate: next, error: null };
					}

					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_FAILURE:
						return { ...state, loading: { ...state.loading, crqsToCreate: false }, error: action.error };

						// ── Creations: Get CRQs on Queue with Error ────────────────────────────────
					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_REQUEST:
						return { ...state, loading: { ...state.loading, crqsOnQueueWithError: true }, error: null };

					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_SUCCESS: {
						const next = action.payload ?? [];
						if (isSameData(state.crqsOnQueueWithError, next))
							return { ...state, loading: { ...state.loading, crqsOnQueueWithError: false } };
						return { ...state, loading: { ...state.loading, crqsOnQueueWithError: false }, crqsOnQueueWithError: next, error: null };
					}

					case HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_FAILURE:
						return { ...state, loading: { ...state.loading, crqsOnQueueWithError: false }, error: action.error };

						// ── Creations: Action (Reset / Delete / ChangeBot) ────────────────────────
					case HELIX_CRQS_ACTIONS.HC_CRQS_ACTION_REQUEST:
						return { ...state, loading: { ...state.loading, crqsAction: true }, error: null };

					case HELIX_CRQS_ACTIONS.HC_CRQS_ACTION_SUCCESS:
						return { ...state, loading: { ...state.loading, crqsAction: false } };

					case HELIX_CRQS_ACTIONS.HC_CRQS_ACTION_FAILURE:
						return { ...state, loading: { ...state.loading, crqsAction: false }, error: action.error };

					default:
						return state;
	}
};

export default HelixCrqsReducer;